import { render, staticRenderFns } from "./VTitlePreview.vue?vue&type=template&id=111228a2&"
import script from "./VTitlePreview.vue?vue&type=script&lang=js&"
export * from "./VTitlePreview.vue?vue&type=script&lang=js&"
import style0 from "./VTitlePreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports